/*
 * @Description: 配置main.js
 * @Autor: kangpeng
 * @Date: 2020-04-17 10:17:41
 * @LastEditors: kangpeng
 * @LastEditTime: 2020-07-14 10:09:45
 */
import Vue from 'vue'
import ElementUI from 'element-ui';
import VueLazyload from 'vue-lazyload'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'element-ui/lib/theme-chalk/index.css';
import 'swiper/css/swiper.css'
import App from './App.vue'
import {
    get,
    post
} from '../utils/axios.js';
import router from './router';
import mtils from 'mtils';
import BaiduMap from 'vue-baidu-map';
import './static/css/element-variables.scss'
import './static/css/normalize.css'
import * as filters from '../utils/filters'
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
Vue.prototype.mtils = mtils
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */ )
// Vue.use(VueLazyload, {
//     preLoad: 1.3,
//     error: 'dist/error.png',
//     throttleWait: 500,
//     loading: 'dist/loading.gif',
//     attempt: 1
// })
Vue.use(ElementUI);
Vue.use(BaiduMap, {
    ak: '5bqrO0WLuwhuWbeuKinI184gyys5yrvQ'
})
new Vue({
    router,
    render: h => h(App)
}).$mount('#app')